export default theme => ({
  root: {
    flexGrow: 1,
  },
  card: {
    height: theme.spacing.unit * 90,
    overflowY: 'auto',
  },
  total: {
    float: 'left',
    margin: theme.spacing.unit * 2,
    color: 'grey',
  },
  gridContainer: {
    padding: theme.spacing.unit,
  },
  chip: {
    margin: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/students/cards/StudentListCard/styles.js